module.exports = __webpack_public_path__ + "facebook.png?0221eb0509e1c2799fad1e126ab2cf4c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/facebook.png
// module id = 87
// module chunks = 0